import React from 'react';
import { Route } from 'react-router-dom';

const ModulesComponent = React.lazy(() => import('./Modules'));
const ModulesRouter = <Route path="modules" element={<ModulesComponent />} />;

export default ModulesRouter;
